var module = angular.module('octopusApp.infrastructure');

module.factory('octoDirectory', function () {
  var map = [];
  map.push({ prefix: "actiontemplates-", redirect: function (id) { return "#/library/steptemplates/" + id; }});
  map.push({ prefix: "deployments-", redirect: function (id) { return "#/deployments/" + id; } });
  map.push({ prefix: "environments-", redirect: function (id) { return "#/environments/" + id; } });
  map.push({ prefix: "feeds-", redirect: function (id) { return "#/library/feeds/" + id; } });
  map.push({ prefix: "libraryvariablesets-", redirect: function (id) { return "#/library/variables/" + id; }});
  map.push({ prefix: "lifecycles-", redirect: function (id) { return "#/library/lifecycles/" + id; }});
  map.push({ prefix: "machinepolicies-", redirect: function (id) { return "#/environments/machinepolicies/" + id; }});
  map.push({ prefix: "machines-", redirect: function (id) { return "#/machines/" + id; } });
  map.push({ prefix: "projects-", redirect: function (id) { return "#/projects/" + id; } });
  map.push({ prefix: "projectgroups-", redirect: function (id) { return "#/projectgroups/" + id; } });
  map.push({ prefix: "proxies-", redirect: function (id) { return "#/environments/proxies/" + id; } });
  map.push({ prefix: "releases-", redirect: function (id) { return "#/releases/" + id; } });
  map.push({ prefix: "servertasks-", redirect: function (id) { return "#/tasks/" + id; } });
  map.push({ prefix: "tagsets-", redirect: function (id) { return "#/library/tagsets/" + id; }});
  map.push({ prefix: "teams-", redirect: function (id) { return "#/configuration/teams/" + id; } });
  map.push({ prefix: "tenants-", redirect: function (id) { return "#/tenants/" + id; } });
  map.push({ prefix: "users-", redirect: function (id) { return "#/configuration/users/" + id; } });
  map.push({ prefix: "subscriptions-", redirect: function (id) { return "#/configuration/subscriptions/" + id; } });
  map.push({ prefix: "certificates-", redirect: function (id) { return "#/library/certificates/" + id; } });

  return {
    linkTo: function(id) {
      if (!id) {
        return '';
      }

      var lower = id.toLowerCase();

      for (var i = 0; i < map.length; i++) {
        var mapEntry = map[i];
        if (lower.indexOf(mapEntry.prefix) === 0) {
          return mapEntry.redirect(id);
        }
      }

      return '#/not-found';
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/octo_directory.js
// module id = 8998961063442882
// module chunks = 1